import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { SecretariatStore, LocaleStore, DutyAssignmentStore } from '../../store';
import { TLCode } from '../../common/enums';
import { Instance } from 'mobx-state-tree';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import BaseGrid from '../common/grid/BaseGrid';
import moment from 'moment';
import { renderGridDate } from '../../store/utils';
import DeleteCell from '../common/grid/DeleteCell';
import { ColDef, ICellRendererParams } from 'ag-grid-community';

interface PharmacyDutiesListProps extends WithTranslateProps {
  dataList: Array<Instance<any>>;
  DutyAssignmentStore?: Instance<typeof DutyAssignmentStore>;
  onDelete: (id: number) => void;
}

@inject('SecretariatStore', 'LocaleStore', 'DutyAssignmentStore')
@observer
class PharmacyDutiesList extends React.Component<PharmacyDutiesListProps> {
  getDayValue = ({ colDef, data }) => {
    return moment(data.date).format('dddd');
  };

  private getColumnDefs = (): ColDef[] => {
    const { translate } = this.props;
    return [
      {
        // headerName: translate(TLCode.PHARMACIES_ApbNum),
        field: 'id',
        sort: 'desc',
        hide: true
      },
      {
        headerName: translate(TLCode.PHARMACIES_ApbNum),
        field: 'apbNumber',
        width: 90
      },
      {
        headerName: translate(TLCode.DUTYASSIGNMENT_Pharmacy),
        field: 'pharmacyName',
      },
      {
        headerName: '',
        field: 'city',
      },      {
        headerName: translate(TLCode.DUTYASSIGNMENT_DAY_OF_WEEK),
        field: 'day',
        valueGetter: this.getDayValue,
        width: 90
      },
      {
        headerName: translate(TLCode.DUTYASSIGNMENT_Date),
        field: 'date',
        cellRenderer: renderGridDate,
        width: 120
      },
      {
        headerName: translate(TLCode.DUTYASSIGNMENT_Type),
        field: 'type',
        width: 80
      },
      {
        headerName: '',
        width: 50,
        cellRendererFramework: DeleteCell,
        cellRendererParams: (params: ICellRendererParams) => {
          return {
            onDeleteButtonClick: async () => {
              // await this.props.DutyAssignmentStore!.unassignDuty(params.data.id);
              this.props.onDelete(params.data.id);
            },
          };
        },
      },
    ];
  };

  render() {
    const { dataList } = this.props;

    return <BaseGrid keyName="id" columnDefs={this.getColumnDefs()} rowData={dataList} />;
  }
}

export default withTranslate(PharmacyDutiesList);
